<template>

<div>
  <PageTitle :route="$route" />

  <PageRowWrapper>
    <MaintanceReasonForm />
  </PageRowWrapper>
</div>

</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import MaintanceReasonForm from '@/components/settings/test-registers/maintanceReason/MaintanceReasonForm'

export default {
  name: 'MaintanceReasons',
  components: {
    PageTitle,
    PageRowWrapper,
    MaintanceReasonForm
  }
}
</script>
